import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from '../shared/globals/globals';
import { TeiasoftLoaderService } from '../shared/services/teiasoft-bucket/teiasoft-loader.service';
import { BackendService } from '../shared/services/backend/backend.service';
import { UserLogged } from '../shared/models/data/userLogged.model';
import { TeiasoftModalService } from '../shared/services/teiasoft-bucket/teiasoft-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { UserToLogin } from '../shared/models/data/userToLogin.model';
import { UtilsService } from '../shared/services/utils/utils.service';
import { UserConfiguration } from '../shared/models/data/userConfiguration.model';
import { GridConfiguration } from '../shared/teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component';
import { TeiasoftToasterService } from '../shared/services/teiasoft-bucket/teiasoft-toaster.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  appVersion: string = "Ver. 1.0.0";
  private returnUrl: string | null = null;

  constructor(public globals: Globals, private router: Router, private route: ActivatedRoute, public teiasoftLoader: TeiasoftLoaderService, private backendService: BackendService,
    private teiasoftModal: TeiasoftModalService, private translate: TranslateService, private utilsService: UtilsService, private toast: TeiasoftToasterService) {

  }

  ngOnInit(): void {
    this.utilsService.setLanguageTranslateAndDateFormat();
    const rawReturnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    this.returnUrl = this.normalizeReturnUrl(rawReturnUrl);
  }

  /* METHODS */
  loginUser(user: string, pwd: string) {
    this.teiasoftLoader.start();
    let _userToLogin = new UserToLogin();
    _userToLogin.username = user;
    _userToLogin.password = pwd;
    _userToLogin.defaultConfiguration = "";

    this.backendService.loginUser(_userToLogin).subscribe(res => {
      this.teiasoftLoader.stop();
      if (res) {
        res.language = res.language!.toLowerCase();
        this.globals.userLogged = new UserLogged();
        Object.assign(this.globals.userLogged, res);
        localStorage.setItem("userLogged", JSON.stringify(this.globals.userLogged!));
        localStorage.setItem("token", res.token!);
        this.utilsService.setLanguageTranslateAndDateFormat().subscribe(() => {

          // Get Theme from UserConfigration
          if (this.globals.userLogged!.configuration != '') {
            let _conf: UserConfiguration = new UserConfiguration();
            _conf = JSON.parse(this.globals.userLogged!.configuration!);
            this.globals.theme = _conf.theme;
            this.navigateAfterLogin();
          } else {
            // If there's no configuration (typically, first login) create default configuration
            this.setDefaultUserConfiguration();
          }

        });

      }
    }, err => {
      this.teiasoftLoader.stop();
      // this.toast.show('error', this.translate.instant("errors." + err.error.status + err.error.type));
    });
  }

  private navigateAfterLogin(): void {
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl);
      return;
    }

    // itdcr users will start from itdcr page
    if (this.utilsService.isAuthorized('Global', 'Itdcr', null)) {
      this.router.navigate(["/view-itdcrs"]);
      return;
    }

    this.router.navigate(["/enquiry-book"]);
  }

  setDefaultUserConfiguration() {
    // Prepare UserConfiguration Object
    let _userConfiguration: UserConfiguration = new UserConfiguration();
    _userConfiguration.theme = 'silver';
    this.globals.theme = _userConfiguration.theme; // Assign Theme

    // Grid Configuration - Enquiry
    _userConfiguration.gridsConfigurations = new Array();
    let _gridConfiguration: GridConfiguration = new GridConfiguration();
    _gridConfiguration.name = 'EnquiryBook';
    _gridConfiguration.defaultFilterView = 'GetAll';
    _gridConfiguration.gridColumns = new Array();
    _userConfiguration.gridsConfigurations.push(_gridConfiguration);

    // Grid Configuration - Logs
    _gridConfiguration = new GridConfiguration();
    _gridConfiguration.name = 'Logs';
    _gridConfiguration.defaultFilterView = '';
    _gridConfiguration.gridColumns = new Array();
    _userConfiguration.gridsConfigurations.push(_gridConfiguration);

    // Grid Configuration - History
    _gridConfiguration = new GridConfiguration();
    _gridConfiguration.name = 'History';
    _gridConfiguration.defaultFilterView = '';
    _gridConfiguration.gridColumns = new Array();
    _userConfiguration.gridsConfigurations.push(_gridConfiguration);

    // Grid Configuration - GetNormGrades
    _gridConfiguration = new GridConfiguration();
    _gridConfiguration.name = 'getNormGrades';
    _gridConfiguration.defaultFilterView = '';
    _gridConfiguration.gridColumns = new Array();
    _userConfiguration.gridsConfigurations.push(_gridConfiguration);

    // Grid Configuration - GetRawMaterialGrades
    _gridConfiguration = new GridConfiguration();
    _gridConfiguration.name = 'getRawMaterialGrades';
    _gridConfiguration.defaultFilterView = '';
    _gridConfiguration.gridColumns = new Array();
    _userConfiguration.gridsConfigurations.push(_gridConfiguration);

    // Grid Configuration - GetCustomersWithBonusAgreement
    _gridConfiguration = new GridConfiguration();
    _gridConfiguration.name = 'getCustomersWithBonusAgreement';
    _gridConfiguration.defaultFilterView = '';
    _gridConfiguration.gridColumns = new Array();
    _userConfiguration.gridsConfigurations.push(_gridConfiguration);

    // Grid Configuration - GetSms
    _gridConfiguration = new GridConfiguration();
    _gridConfiguration.name = 'getSms';
    _gridConfiguration.defaultFilterView = '';
    _gridConfiguration.gridColumns = new Array();
    _userConfiguration.gridsConfigurations.push(_gridConfiguration);

    // Assign to globals and save
    this.globals.userLogged!.configuration = JSON.stringify(_userConfiguration);
    this.backendService.updateUserConfiguration(this.globals.userLogged!.configuration!, this.globals.userLogged!.language!, this.globals.userLogged!.dateFormat!).subscribe(res => {
      this.navigateAfterLogin();
    });
  }

  /* EVENTS */
  onLoginClick(obj: any) {
    this.loginUser(obj["userName"], obj["password"]);
  }

  keyU(obj: any) {
    this.loginUser(obj["userName"], obj["password"]);
  }

  private normalizeReturnUrl(rawReturnUrl: string | null): string | null {
    if (!rawReturnUrl) return null;
    if (rawReturnUrl.startsWith('/login')) return null;
    if (!rawReturnUrl.startsWith('/') || rawReturnUrl.startsWith('//') || rawReturnUrl.includes('://')) {
      return null;
    }
    return rawReturnUrl;
  }
}
